/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SettingType {
    Undefined = -1,
    Integer = 0,
    Boolean = 1,
    String = 2,
    Password = 3,
    Double = 4,
    ListOfStrings = 5,
}
